import React from "react"
import createReactClass from "create-react-class"
import PropTypes from "prop-types"
import classNames from "classnames"

import styles from "./list-item.less"

var defaultRoute = "#"

export default createReactClass({
  displayName: "ListItem",
  getDefaultProps() {
    return {
      disabled: false,
      invisible: false,
      active: false,
      url: defaultRoute,
      onClick: () => {},
    }
  },
  propTypes: {
    active: PropTypes.bool,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    invisible: PropTypes.bool,
    disabled: PropTypes.bool,
    url: PropTypes.string,
    onClick: PropTypes.func,
  },
  getItems() {
    return React.cloneElement(this.props.children, {
      active: this.props.active,
    })
  },
  handleClick() {
    this.props.onClick(this.props.value)
  },
  handleLinkClick(e) {
    if (this.props.url == defaultRoute) {
      e.preventDefault()
    }
  },
  getClass() {
    return classNames(styles.listItem, {
      active: this.props.active,
      disabled: this.props.disabled,
    })
  },
  render() {
    return this.props.invisible ? null : (
      <li className={this.getClass()} onClick={this.handleClick}>
        <a ref="link" href={this.props.url} onClick={this.handleLinkClick} className={styles.link}>
          {this.getItems()}
        </a>
      </li>
    )
  },
})
